<template>
  <el-tag type="danger">
    <!-- Identity warning -->
    <template v-if="type === VerificationType.PaymentProfile">
      To activate these payment method, please
      <router-link
        v-if="sid"
        :to="`/payment/verification/${sid}`"
        class="el-button el-button--danger"
      >
        fill payment profile
      </router-link>
      <span v-else> verify your ID </span>
    </template>
    <!-- Identity warning -->
    <template v-if="type === VerificationType.Identity">
      To activate these payment method, please
      <router-link
        v-if="sid"
        :to="`/payment/verification/${sid}`"
        class="el-button el-button--danger"
      >
        verify your ID
      </router-link>
      <span v-else> verify your ID </span>
    </template>
    <!-- Profile (contact) warning -->
    <template v-if="type === VerificationType.Profile">
      To activate these payment method, please
      <span class="el-button el-button--danger" @click="modal">
        fill your profile
      </span>
    </template>
    <!-- Country mismatch warning -->
    <template v-if="type === VerificationType.Country">
      Payment method is not allowed in your country
    </template>
    <!-- Agreement warning -->
    <template v-if="type === VerificationType.Agreement">
      <!-- temporary disabled -->
      To activate these payment method, please sign agreement
    </template>
    <!-- Contact type mismatch warning -->
    <template
      v-if="
        type === VerificationType.ContactType || type === VerificationType.User
      "
    >
      Payment method is not allowed for your account
    </template>
  </el-tag>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { VerificationType } from '@/api/types'

export default defineComponent({
  name: 'RequirementsLabel',
  props: {
    type: {
      type: String,
      required: true
    },
    sid: {
      type: String,
      default: ''
    }
  },
  setup(_props, context) {
    const modal = () => {
      context.emit('modal')
    }
    return { VerificationType, modal }
  }
})
</script>

<style lang="scss" scoped>
.el-tag {
  border: none !important;
  font-size: 20px;
  padding-right: 0;
}
</style>
